'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
  'use strict';

  angular.module('msSleep').component('msSleepDatePicker', {
    templateUrl: 'sleep/templates/ms-sleep-date-picker.html',
    controller: msSleepDatePicker,
    bindings: {
      onGetEntries: '&',
      onSelectedDayChange: '&',
      calendarView: '<',
      disablePaging: '<',
      latestEntry: '<',
      lastNightCompleted: '&',
      initDate: '<'
    }
  });

  msSleepDatePicker.$inject = ['sleepEntrySvc', '$q', 'calUtilities', '$log', 'STANDARD_DATE_FMT'];

  function msSleepDatePicker(sleepEntrySvc, $q, calUtilities, $log, STANDARD_DATE_FMT) {
    var vm = this;
    vm.$onInit = _activate;

    vm.dayCssClasses = function (d) {
      return [].concat(_toConsumableArray(calUtilities.dayCssClasses(d)));
    };
    vm.dayTitles = [].concat(_toConsumableArray(calUtilities.generateDaysOfWeek()));

    vm.updateDateRange = function (startDate, endDate) {
      $log.debug('updateDateRange');
      vm.days = _.flatMap([].concat(_toConsumableArray(calUtilities.generateDay(startDate, endDate))));
      if (vm.calendarView) {
        _getEntries(startDate, endDate).then(function (data) {
          _augmentDaysWithEntries(vm.days, _pickCompleted(data.entries));

          if (_.isFunction(vm.onGetEntries)) {
            var daysCompleted = _getLatestStreakLength(vm.days);
            vm.onGetEntries({
              daysCompleted: daysCompleted,
              hasCompletedStreak: data.completeWeek
            });
          }
        });
      } else {
        _getEntries(startDate, endDate).then(function (data) {
          return _augmentDaysWithEntries(vm.days, _pickCompleted(data.entries));
        });
      }
    };
    vm.setSelectedDay = function (d) {
      if (_.isFunction(vm.onSelectedDayChange)) {
        vm.onSelectedDayChange({
          day: d.date.format(STANDARD_DATE_FMT)
        });
      }
    };

    ////////////////
    function _activate() {
      vm.initDate = moment(vm.initDate);
      vm.yesterday = vm.initDate.clone().subtract(1, 'day');
      vm.nbrOfWeeks = vm.calendarView ? moment.duration(2, 'weeks') : moment.duration(7, 'days');
    }

    function _pickCompleted(entries) {
      return Object.keys(_.pickBy(entries, _.identity));
    }

    // merges multiple weeks of data into one array, marks completed days as completed.
    function _augmentDaysWithEntries(arrayOfWeeks, datesWithEntries) {
      arrayOfWeeks.forEach(function (day) {
        day.isCompleted = datesWithEntries.includes(day.date.format(STANDARD_DATE_FMT));
        day.link = day.date.format(STANDARD_DATE_FMT);
        day.isLastEntry = day.isCompleted && day.link === vm.latestEntry;
      });
    }

    function _getLatestStreakLength(arrayOfDays) {
      var trimmed = _.dropRightWhile(arrayOfDays, function (d) {
        return !d.isCompleted;
      });
      return _.takeRightWhile(trimmed, function (d) {
        return d.isCompleted;
      }).length;
    }

    function _getEntries(startDate, endDate) {
      return sleepEntrySvc.getEntries(startDate, endDate, true).then(function (data) {
        var lastNight = vm.yesterday.format(STANDARD_DATE_FMT);
        vm.lastNightCompleted({
          completed: data.entries[lastNight] ? true : false
        });
        return data;
      });
    }
  }
})();